module.exports = __webpack_public_path__ + "static/media/Rectangle 93.5b11f072.png";